import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { X } from "@phosphor-icons/react";
import React from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import ANUploader from "elements/ANUploader";
import useANUploader from "hooks/utils/useANUploader";
import { useUploadCustomerDocument } from "hooks/useUploadCustomerDocument";
import { getAWSCredentialsForCurrentUserSession } from "utils/aws";
import * as AWS from "aws-sdk";
import { v4 as uuidv4 } from "uuid";

export default function UploadAttachmentDialog({
  open,
  handleClose,
  uploading,
  setUploading,
  cognitoId,
  sendMessage,
  clientId,
  user,
}) {
  const { handleFileUpload, dropzoneFiles, handleFileDelete, setDropzoneFiles } = useANUploader();
  const { uploadDocument } = useUploadCustomerDocument();

  const submitDocumentUpload = async () => {
    setUploading(true);
    const file = dropzoneFiles[0].file;
    try {
      const credentials = await getAWSCredentialsForCurrentUserSession();
      const s3 = new AWS.S3({
        credentials,
        apiVersion: "2006-03-01",
        params: { Bucket: process.env.AWS_USER_DOC_BUCKET },
      });
      const fileUUID = uuidv4();
      const [fileName, fileExtension] = file.name.split(".");
      const params = {
        ACL: "authenticated-read",
        Body: file,
        ContentType: file.type,
        Key: `${cognitoId}/${fileName}-${fileUUID}.${fileExtension}`,
      };
      const upload = await s3.upload(params).promise();
      const document = {
        filename: upload.Key.split("/")[1],
        key: upload.Key,
        display_filename: file.name,
        clientId: clientId,
        type: "ATTACHMENT",
        internal: false,
        billing_related: false,
        file_size: file.size,
        uploaded_by: user.id,
      };
      const uploadedDoc = await uploadDocument(document);
      const uploadedDocId = uploadedDoc?.data?.document_id;
      await sendMessage(uploadedDocId);
      setDropzoneFiles([]);
      handleClose();
      setUploading(false);
    } catch (e) {
      console.error(e);
      setUploading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm">
      <DialogTitle>
        Add Attachment
        <IconButton aria-label="close" onClick={handleClose} disabled={uploading}>
          <X />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <ANUploader
          handleFileUpload={handleFileUpload}
          handleFileDelete={handleFileDelete}
          dropzoneFiles={dropzoneFiles}
          setDropzoneFiles={setDropzoneFiles}
          useDropzoneOptions={{ multiple: false }}
          dropZoneStyle={{ margin: 0 }}
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={handleClose} disabled={uploading}>
          Cancel
        </Button>
        <LoadingButton
          onClick={submitDocumentUpload}
          loading={uploading}
          disabled={!dropzoneFiles.length}
        >
          Send Attachment
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
